<template>
    <div>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item>
                    <i class='el-icon-lx-cascades'></i> 保险类型管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container'>
            <div class='handle-box'>
<!--                <el-select v-model='provinceValue' placeholder='请选择省' style='width: 140px;margin-right: 20px'>-->
<!--                    <el-option-->
<!--                        v-for='item in provinceOptions'-->
<!--                        :key='item.provinceValue'-->
<!--                        :label='item.label'-->
<!--                        :value='item.value'>-->
<!--                    </el-option>-->
<!--                </el-select>-->
<!--                <el-select v-model='cityValue' placeholder='请选择市' style='width: 140px;margin-right: 20px'>-->
<!--                    <el-option-->
<!--                        v-for='item in cityOptions'-->
<!--                        :key='item.cityValue'-->
<!--                        :label='item.label'-->
<!--                        :value='item.value'>-->
<!--                    </el-option>-->
<!--                </el-select>-->
<!--                <el-select v-model='enterpiseValue' placeholder='部门' style='width: 140px;margin-right: 20px'>-->
<!--                    <el-option-->
<!--                        v-for='item in enterpiseOptions'-->
<!--                        :key='item.value'-->
<!--                        :label='item.label'-->
<!--                        :value='item.value'>-->
<!--                    </el-option>-->
<!--                </el-select>-->
<!--                <el-select v-model='query.status' placeholder='状态' class='handle-select mr10' v-if='true'>-->
<!--                    <el-option key='' label='全部' value=''></el-option>-->
<!--                    <el-option key='1' label='禁用' value='0'></el-option>-->
<!--                    <el-option key='2' label='正常' value='1'></el-option>-->
<!--                </el-select>-->
<!--                <el-input v-model='query.name' placeholder='部门名称' class='handle-input mr10'-->
<!--                          style='width: 140px;margin-right: 20px'></el-input>-->
                <el-button type='primary' icon='el-icon-search' @click='handleSearch'>查询</el-button>
                <el-button type='primary'  @click='addUser'>添加保险类型</el-button>
            </div>
            <el-table
                :data='tableData'
                border
                class='table'
                ref='multipleTable'
                row-key="id"
                border
                default-expand-all
                :tree-props="{children: 'childrens', hasChildren: 'hasChildren'}"
                header-cell-class-name='table-header'
            >
                <el-table-column label='序号' align='center' :index='indexMethod' width='40' type='index'>
                </el-table-column>

                <el-table-column label='保险类型大类' align='center'>
                    <template slot-scope='scope'>{{ scope.row.name }}</template>
                </el-table-column>

                <el-table-column label='操作' width='180' align='center'>
                    <template slot-scope='scope'>
<!--                        <el-button-->
<!--                            type='text'-->
<!--                            v-if='scope.row.level!=2'-->
<!--                            @click='addLevel(scope.$index, scope.row)'-->
<!--                        >新增子级-->
<!--                        </el-button>-->
                        <el-button
                            type='text'
                            @click='handleEdit(scope.$index, scope.row)'
                        >编辑
                        </el-button>
                        <el-button
                            type='text'
                            class='red'
                            @click='handleDelete(scope.$index, scope.row)'
                        >删除
                        </el-button>

                    </template>
                </el-table-column>

            </el-table>
            <div class='pagination'>
                <el-pagination
                    background
                    layout='total, prev, pager, next'
                    :current-page='query.pageIndex'
                    :page-size='query.pageSize'
                    :total='pageTotal'
                    @current-change='handlePageChange'
                ></el-pagination>
            </div>
        </div>
        <el-dialog title='添加保险类型' :visible.sync='addVisible' width='40%'>


            <el-form ref='form' :model='createForm' label-width='120px'>
                <el-form-item label='保险类型名称'>
                    <el-input v-model='createForm.name' maxlength='11'></el-input>
                </el-form-item>

            </el-form>
            <span slot='footer' class='dialog-footer'>
                <el-button @click='addVisible = false'>取 消</el-button>
                <el-button type='primary' @click='addUserHttp'>确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title='编辑保险类型' :visible.sync='editVisible' width='40%'>


            <el-form ref='form' :model='form' label-width='120px'>
                <el-form-item label='保险类型名称'>
                    <el-input v-model='form.name' maxlength='11'></el-input>
                </el-form-item>

            </el-form>
            <span slot='footer' class='dialog-footer'>
                <el-button @click='editVisible = false'>取 消</el-button>
                <el-button type='primary' @click='editHttp'>确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title='新增子级' :visible.sync='addLevelVisible' width='40%'>


            <el-form ref='form' :model='addLevelForm' label-width='120px'>
                <el-form-item label='保险类型名称'>
                    <el-input v-model='addLevelForm.name' maxlength='11'></el-input>
                </el-form-item>

            </el-form>
            <span slot='footer' class='dialog-footer'>
                <el-button @click='addLevelVisible = false'>取 消</el-button>
                <el-button type='primary' @click='addLevelHttp'>确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import { countDown, formatDate, formatDates } from '@/utils/formatDate';

export default {
    name: 'basetable',
    data() {
        return {

            query: {
                name: '',
                pageIndex: 1,
                pageSize: 10
            },
            queryEnterprise: {
                name: '',
                pageIndex: 1,
                pageSize: 999999
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            addVisible: false
            ,
            createForm: {}
            ,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
            options: [],
            value: '',
            editCurrentProgress: '1',
            editCurrentProgressName: '',
            provinceOptions: [],
            cityOptions: [],
            provinceValue: '',
            cityValue: '',
            enterpiseOptions: [],
            enterpiseValue: '',
            addLevelVisible:false,
            addLevelForm:{}


        };
    },
    created() {
        this.getData();
        // this.getCity();
        // this.getEnterpise();
    },
    watch: {

        //监听内容
        provinceValue() {
            let that = this;
            this.provinceOptions.forEach(res => {
                this.cityValue = '';


                if (res.value == that.provinceValue) {
                    that.cityOptions = res.children;
                }
            });


        }
    },
    methods: {
        //禁用
        handleForbidden(index, row) {
            // 二次确认删除
            console.log(index);
            console.log(row.uid);
            let that = this;
            let params = {};
            let msg = '';
            if (row.status == 1) {
                msg = '确定要' + '禁用' + '吗？';
                params = { 'id': row.id, 'status': 0 };
            } else {
                msg = '确定要' + '解除禁用' + '吗？';
                params = { 'id': row.id, 'status': 1 };
            }
//0不可用1可用
            this.$confirm(msg, '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.http.post('organize/updateStatus', params).then(res => {
                        if (res.code == 0) {
                            that.getData();
                            this.$message.success('操作成功');
                        }
                    });

                })
                .catch(() => {
                });
        },
        getCity() {
            let that = this;
            // this.http.getToken('serviceProvider/getCity', this.query).then(res => {
            //         if (res.code == 0) {
            //             that.provinceOptions = res.data;
            //             that.options = res.data;
            //
            //         }
            //     },
            //     err => {
            //
            //     });
        },
        getEnterpise() {
            // let that = this;
            // this.http.getToken('/enterprise/getList', this.queryEnterprise).then(res => {
            //         if (res.code == 0) {
            //             that.enterpiseOptions.push({ 'value': '', 'label': "请选择部门" });
            //             res.data.records.forEach(res => {
            //
            //                 that.enterpiseOptions.push({ 'value': res.code, 'label': res.name });
            //             });
            //
            //         }
            //     },
            //     err => {
            //
            //     });
        },
        indexMethod(index) {
            return index + 1;
        },
        getData() {
            let that = this;
            this.query.provinceId = this.provinceValue;
            this.query.cityId = this.cityValue;
            this.query.enterpiseCode = this.enterpiseValue
            this.http.get('workType/query', this.query).then(res => {
                    if (res.code == 0) {
                        that.tableData = res.data;

                        this.$message.success('获取数据成功');

                    }
                },
                err => {

                });
        },
        // 触发搜索按钮
        handleSearch() {
            this.query.pageIndex = 1;
            this.getData();

        },
        delUserHttp(id) {
            let that = this;
            this.http.post('workType/delById', { 'id': id }).then(res => {
                    if (res.code == 0) {
                        that.getData();
                        that.$message.success('删除成功');
                    }
                },
                err => {

                });
        }
        ,
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            let that = this;
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.delUserHttp(row.id);

                })
                .catch(() => {
                });
        },

        addUser() {
            this.addVisible = true;
            this.createForm = {};
            this.createForm.level=1
        },
        addLevelHttp(){
            let that = this;
            this.http.post('/workType/add', this.addLevelForm).then(res => {
                if (res.code === 0) {
                    that.getData();
                    that.addLevelVisible = false;
                    this.$message.success('添加成功');
                }

            });
        },
        addUserHttp() {
            let that = this;
            this.http.post('/workType/add', this.createForm).then(res => {
                if (res.code === 0) {
                    that.getData();
                    that.addVisible = false;
                    this.$message.success('添加成功');
                }

            });
        }
        ,
        editHttp() {
            let that = this;
            let params = {"id":this.form.id,"name":this.form.name}
            this.http.post('workType/update', params).then(res => {
                if (res.code == 0) {
                    that.getData();
                    that.editVisible = false;
                    that.$message.success('编辑成功');
                }

            });
        }
        ,
        // 编辑操作
        addLevel(index, row) {
            this.idx = index;
            this.addLevelForm={}
            this.addLevelForm.level = row.level+1
            this.addLevelForm.parentId = row.id
            this.addLevelVisible = true;
        },
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;

            this.form = JSON.parse(JSON.stringify(row));
            this.form.enterpriseCode=row.enterpriseCode
            this.editCurrentProgressName = this.form.currentProgressName;

            this.editVisible = true;
        },
        // 保存编辑
        saveEdit() {
            this.editVisible = false;
            this.$message.success(`修改第 ${this.idx + 1} 行成功`);
            this.$set(this.tableData, this.idx, this.form);
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>

.avatar-uploader .el-upload {
    border-radius: 6px;
    width: 80px;
    height: 80px;
    text-align: center;

}

.avatar-uploader {
    border-color: #409EFF;
    text-align: center;
    margin-bottom: 40px;
    text-align: center;

}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    text-align: center;
}

.avatar {
    width: 80px;
    height: 80px;
    display: block;
    margin: auto auto;
    text-align: center;
}

.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
